import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../assets/constants";
import { toast } from "react-toastify";
//url for production
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string?.length; i++) {
    if (string.charAt(i) === string.charAt(i) && string.charAt(i) !== " ") {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

export const truncate1 = (str = "", n = 50) => {
  if (typeof str !== "string") return "";
  return str.length > n ? str.slice(0, n) + "…" : str;
};


// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];

//! MY FUNCTIONS
const getToken = () => {
  return localStorage.getItem("accessToken");
};

export const createHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};

export const createFormHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
      XXX: "XXX",
    },
  };
};

// Encryption function
export const encrypt = (data) => {
  const cipherText = CryptoJS.AES.encrypt(JSON?.stringify(data), SECRET_KEY)?.toString();
  return cipherText;
};

export const decrypt = (cipherText) => {
  try {
    const bytes = CryptoJS?.AES?.decrypt(cipherText, SECRET_KEY);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      console.error("Decryption failed: empty string");
      return null;
    }

    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
export function ValidateImgPdf(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
  const allowedExtensions = /\.(png|jpe?g|pdf)$/i;

  // Basic MIME and extension check first
  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }

  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47"; // PNG
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
    const isPdf = header === "25504446"; // PDF

    const isValid = isPng || isJpeg || isPdf;
    callback(isValid);
  };

  reader.onerror = function () {
    callback(false);
  };

  // Read the first 4 bytes of the file
  reader.readAsArrayBuffer(file.slice(0, 4));
}

export function ValidateImg(file, callback) {
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }
    // File signature check
    const isPng = header === "89504e47"; // PNG signature
    const isJpeg =
      header === "ffd8ffe0" || // JPEG signature
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    const isValidImage = isPng || isJpeg;
    callback(isValidImage); // Pass the result to the callback function
  };
  reader.onerror = function () {
    callback(false); // In case of an error, return false
  };
  reader.readAsArrayBuffer(file.slice(0, 4)); // Read the first 4 bytes of the file
}

export const handleStatusChange = (setValue, selectedOption, trigger) => {
  setValue("status", selectedOption || "");
  trigger("status");
};
export const handleSelectChange = (
  selectedOption,
  name,
  setValue,
  trigger,
  multi,
  max
) => {
  // Allow clear
  if (!selectedOption) {
    setValue(name, "");
    trigger(name);
    return;
  }

  //  Max limit for multi-select
  if (multi && max && Array.isArray(selectedOption) && selectedOption.length > max) {
    toast.error(`You can select maximum ${max} specializations`, {
      autoClose: 1000, // ⏱️ 1 second
      toastId: `${name}-max-limit`,
    });
    return;
  }

  setValue(name, selectedOption);
  trigger(name);
};
export const handleImageChange = (e, errorInput, url, setValue, setError, trigger, clearErrors) => {
  const file = e.target.files[0];
  if (file) {
    ValidateImg(file, (isValid) => {
      if (isValid) {
        setValue(errorInput, file); // Set as File object, not string
        const imageUrl = URL.createObjectURL(file);
        setValue(url, imageUrl);
        trigger(errorInput);
        setTimeout(() => clearErrors(errorInput), 100);
      } else {
        setError(errorInput, {
          type: "manual",
          message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
        });
        e.target.value = "";
      }
    });
  } else {
    setValue(errorInput, "");
  }
};
export const handleImgPdfChange = (e, errorInput, url, setValue, setError, trigger, clearErrors) => {
  const file = e.target.files[0];
  if (file) {
    ValidateImageAndPdf(file, (isValid) => {
      if (isValid) {
        setValue(errorInput, file); // Set as File object, not string
        const imageUrl = URL.createObjectURL(file);
        setValue(url, imageUrl);
        trigger(errorInput);
        setTimeout(() => clearErrors(errorInput), 100);
      } else {
        setError(errorInput, {
          type: "manual",
          message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
        });
        e.target.value = "";
      }
    });
  } else {
    setValue(errorInput, "");
  }
};
export const isValidEmail = (email) => {
  // const pattern = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._]*@(?=[a-zA-Z])([a-zA-Z]+\.[a-zA-Z]{2,})$/;
  const pattern = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._]*[a-zA-Z0-9]@[a-zA-Z][a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email);
};
//! validate indian mobile number starting with 6,7,8,9
export const validateINMobile = (mobile) => {
  if (/^[6-9]\d{9}$/.test(mobile)) {
    return true;
  }
  return false;
};

export function ValidateImageAndPdf(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
  const allowedExtensions = /\.(png|jpe?g|pdf)$/i;

  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }

  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47";
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
    const isPdf = header === "25504446";

    callback(isPng || isJpeg || isPdf);
  };

  reader.onerror = function () {
    callback(false);
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
}
export function ValidateImageOnly(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg","image/jpg"];
  const allowedExtensions = /\.(png|jpe?g)$/i;

  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }

  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47"; // PNG
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    callback(isPng || isJpeg);
  };

  reader.onerror = function () {
    callback(false);
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
}

export const getSmartInitials = (fullName) => {
  if (!fullName) return '';
  const names = fullName.trim().split(/\s+/);
  const firstInitial = names[0].charAt(0).toUpperCase();
  const secondInitial = names.length > 1
    ? names[names.length - 1].charAt(0).toUpperCase()
    : 'A';
  return firstInitial + secondInitial;
}
